import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LottieCacheModule, LottieModule } from 'ngx-lottie';
import { LandingSystemImgComponent } from './landing-system-img.component';
import { SystemIconModule } from '@app/transactions/components/transaction-form/system-icon/system-icon.module';

export function playerFactory(): Promise<any> {
    return import('lottie-web');
}
@NgModule({
    declarations: [LandingSystemImgComponent],
    exports: [LandingSystemImgComponent],
    imports: [CommonModule, SystemIconModule, LottieModule.forRoot({ player: playerFactory }), LottieCacheModule.forRoot()]
})
export class LandingSystemImgModule {}
